import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  NgModule,
  NO_ERRORS_SCHEMA,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {FormControl, FormGroup, FormBuilder, Validators, ReactiveFormsModule, FormsModule} from '@angular/forms';
import {NgbActiveModal, NgbModal, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import { Account_report } from '../account_report';
import { SharedService } from '../../../../services/index';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import {ConfirmationService} from 'primeng/api';
import {Message} from 'primeng/components/common/api';
import {MessageService} from 'primeng/components/common/messageservice';
import { AppLogComponent } from '../../../../components/app-log/app-log.component'
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {ItemService} from "../../../../services/item.service";
import {PurchasesShowComponent} from "../../../pro/purchases/purchases-show/purchases-show.component";
import {InvoicesShowComponent} from "../../../pos/invoices/invoices-show/invoices-show.component";
import {ReturninvoicesShowComponent} from "../../../pos/returninvoices/returninvoices-show/returninvoices-show.component";
import {RecieptVouchersShowComponent} from "../../reciept_vouchers/reciept_vouchers-show/reciept_vouchers-show.component";
import {ExpenseVouchersShowComponent} from "../../expense_vouchers/expense_vouchers-show/expense_vouchers-show.component";
import {ConfirmDialogModule, DropdownModule} from "primeng/primeng";
import {CommonModule} from "@angular/common";
import {MyInputsModule} from "../../../../my-inputs/my-inputs.module";
import {AccountsService} from "../../accounts/accounts.service";
import {CustomerService} from "../../../setting/customers/customer.service";
import { AccountReportService} from "../account_report.service";
import {JournalsShowComponent} from "../../journals/journals-show/journals-show.component";
import {CostcentersService} from "../../costcenters/costcenters.service";
import {RequestOptions, ResponseContentType} from "@angular/http";
import {appConfig} from "../../../../app.config";


@NgModule({
  imports: [CommonModule, FormsModule, DropdownModule, MyInputsModule, ReactiveFormsModule, ConfirmDialogModule, TranslateModule.forChild()
  ],
  declarations: [
    Account_reportListComponent
  ],
  entryComponents: [
    Account_reportListComponent
  ],
  exports: [],
  providers: [SharedService,  MessageService, ConfirmationService, AccountsService,ItemService,AccountReportService,CostcentersService],
  schemas: [NO_ERRORS_SCHEMA]
})


@Component({
  selector: 'app-account_report-list',
  templateUrl: './account_report-list.component.html',
  styleUrls: ['./account_report-list.component.scss'],
  providers: [ ConfirmationService, MessageService, CustomerService, ItemService, AccountsService,AccountReportService,CostcentersService]
})
export class Account_reportListComponent implements OnInit {
  public items: any[]=[];
  public totalRec: number;
  public page: number;
  public per_page: number;
  public sortCol = '';
  public colname = '';
  public creationid = '';
  public sum: any = [];
  public sumval: any = [];
  public account:any;
  public costCenter:any;
  balances = [0];
  oldData:any;
  startcount = 0;

  docTypes = ['','Other','Purchases','Purchases Return','Invoice','Invoice Return','Reciept Voucher','Expense Voucher'];

  public systemName = '';
  public userid = 0;

  filterdata: any ={};
  filterForm: FormGroup;
  msgs: Message[] = [];
  fromDate='';
  toDate='';

  @Input() account_id;
  @Input() cost_center_id;
  @Input() from_date;
  @Input() to_date;

  @Input() refShow;
  @Output() update_event = new EventEmitter();

  public columns: any[]=[];
  public selected: any[];
  public allcolumns: any;
  public listcolumns: any[]=[];
  public userRoles: any[]=[];
  public hiddenFields: any[] = [];


  private _searchButton: any;
  private _printButton: any;
  private _excelButton: any;

  modelName = 'account_report';

  componentData:any;

  constructor ( private router: Router,
                private route: ActivatedRoute,
                private itemService: ItemService,
                private costCenterService: CostcentersService,
                private accountReportService: AccountReportService,
                public activeModal: NgbActiveModal,
                public translate: TranslateService,
                private formBuilder: FormBuilder,
                private sharedservice: SharedService,
                private modalService: NgbModal,
                private confirmationService: ConfirmationService,
                private messageService: MessageService ) {
    this.sharedservice.setTitle(this.route.snapshot.data.title);
    this.sharedservice.setButtons([
      { label: 'Print', icon: 'fa-print', btnClass: 'btn-skype', btnId: 'printButton' },
      { label: 'Export Excel', icon: 'fa-file-excel-o', btnClass: 'btn-instagram', btnId: 'excelButton' },
      { label: 'Query', icon: 'fa-search', btnClass: 'btn-primary', btnId: 'searchButton' },
    ]);
    this.oldData = {'debit':0,'credit':0};

  }

  total_debit() {
    let totalDebit = this.oldData.debit;
    for(let i=0;i<this.items.length;i++) {
      totalDebit += parseFloat(this.items[i].debit);
    }
    return totalDebit;
  }
  total_credit() {
    let totalCredit = this.oldData.credit;
    for(let i=0;i<this.items.length;i++) {
      totalCredit += parseFloat(this.items[i].credit);
    }
    return totalCredit;
  }

  ngOnInit() {
    const userdata = JSON.parse(localStorage.getItem('currentUser'));
    if (userdata) {
      this.userRoles = userdata.roles.description;
      this.systemName = userdata.systems[0];
      this.userid = userdata.id;
    }

    this.loadingPage();
  }

  balance(valued,valuec,i) {
    this.balances[i] = this.balances[i-1]+(parseFloat(valued)-parseFloat(valuec));
    return this.balances[i];
  }

  loadingPage() {
    this.sharedservice.setTitle(this.route.snapshot.data.title);
    this.update_event.emit(null);
    this.refShow = this.sharedservice.getItemShow();
    this.itemService.urlString = 'account_report';

    if (localStorage.getItem('filter')) {
      this.filterdata = JSON.parse(localStorage.getItem('filter'));
      this.fromDate = this.filterdata['from_date'];
      this.toDate = this.filterdata['to_date'];
    } else if (!this.account_id && !this.cost_center_id) {
      this.redirectNewPage();
    }
    if (!this.account_id && !this.cost_center_id) {
    this._searchButton = document.getElementById('searchButton');
    this._printButton = document.getElementById('printButton');
    this._excelButton = document.getElementById('excelButton');

    if (this._searchButton) {
      this._searchButton.onclick = ((e: any) => {
        e.preventDefault();
        this.redirectNewPage();
      });
    }

    if (this._printButton) {
      this._printButton.onclick = ((e: any) => {
        e.preventDefault();
        this.print();
      });


    }

    if (this._excelButton) {
      this._excelButton.onclick = ((e: any) => {
        e.preventDefault();
        this.excel();
      });

    }
  }
    this.getAll();

}

  print() {
    const params = new URLSearchParams();
    if(this.account_id || this.cost_center_id) {
      if(this.account_id) {
        params.set('filter[account_no]', this.account_id);
      }
      if(this.cost_center_id) {
        params.set('filter[cost_center_id]', this.cost_center_id);
      }
      if(this.from_date) {
        params.set('filter[from_date]', this.from_date);
      }
      if(this.to_date) {
        params.set('filter[to_date]', this.to_date);
      }
    } else {
      let currentfilter = JSON.parse(localStorage.getItem('filter'));
      for (let key in currentfilter) {
        if(currentfilter[key]) {
          params.set('filter[' + key + ']', currentfilter[key]);
        }
      }
    }


      const userdata = JSON.parse(localStorage.getItem('currentUser'));
      const tokenapi = userdata.api_token;
      const options = new RequestOptions({responseType: ResponseContentType.Blob });
      params.set('token', tokenapi);
      window.open(appConfig.apiUrl +this.modelName+ '/print?'+ params.toString() );
    }

  excel2() {
    this.confirmationService.confirm({
      header: this.translate.instant('Print Excel Sheet'),
      message: this.translate.instant('Are_you_Excel?'),
      icon: 'fa fa-file-excel-o',
      accept: () => {
        this.itemService.printlist2(this.sortCol,this.columns,this.modelName,'excel',JSON.stringify(this.sum));
      },
      reject: () => {
        this.itemService.printlist2(this.sortCol,this.sharedservice.getColums(),this.modelName,'excel');
      }
    });
  }

  excel() {
    const params = new URLSearchParams();
    let currentfilter = JSON.parse(localStorage.getItem('filter'));
    for (let key in currentfilter) {
      if(currentfilter[key]) {
        params.set('filter[' + key + ']', currentfilter[key]);
      }
    }

    const userdata = JSON.parse(localStorage.getItem('currentUser'));
    const tokenapi = userdata.api_token;
    const options = new RequestOptions({responseType: ResponseContentType.Blob });
    params.set('token', tokenapi);
    window.open(appConfig.apiUrl +this.modelName+ '/excel?'+ params.toString() );
  }


  loadPage(page: number) {
    if (page !== this.page) {
      this.page = page;
      this.getAll();
    }
  }

  redirectNewPage() {
    this.router.navigate(['/'+this.modelName]);
  }

  sortPage(sortCol: string) {
    if (sortCol === this.sortCol) {
      sortCol = '-' + sortCol;
    } else {
      this.page = 1;
    }
    this.sortCol = sortCol;
    this.getAll();
  }

  getAll() {
    if(this.account_id || this.cost_center_id) {
      this.accountReportService.getByData(this.account_id,this.cost_center_id, this.from_date , this.to_date).subscribe(
        items => {
          this.items = items.dataarr;
          this.account = items.account;
          this.costCenter = items.costcenter;
          this.oldData = items.older;
          this.fromDate = this.from_date;
          this.toDate = this.to_date;
          this.balances[0] = this.oldData.debit - this.oldData.credit;
        },
        err => {
          console.log(err);
        });
    } else {
      this.itemService.getAll(this.page, this.sortCol , JSON.stringify(this.sum)).subscribe(
        items => {
          this.items = items.dataarr;
          this.account = items.account;
          this.costCenter = items.costcenter;
          this.oldData = items.older;
          this.balances[0] = this.oldData.debit - this.oldData.credit;
        },
        err => {
          console.log(err);
        });
    }
  }

  openpopup(doc,type) {
    if(type === 0) {
      const modalRef = this.modalService.open(JournalsShowComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.scrId = doc;
    } else if(type === 2) {
      const modalRef = this.modalService.open(PurchasesShowComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.scrId = doc;
    } else if(type === 3){
      //const modalRef = this.modalService.open(Retu);
    } else if(type === 4){
      const modalRef = this.modalService.open(InvoicesShowComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.scrId = doc;
    } else if(type === 5){
      const modalRef = this.modalService.open(ReturninvoicesShowComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.scrId = doc;
    } else if(type === 6){
      const modalRef = this.modalService.open(RecieptVouchersShowComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.scrId = doc;
    } else if(type === 7){
      const modalRef = this.modalService.open(ExpenseVouchersShowComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.scrId = doc;
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/views/fin/account_report/account_report-list/account_report-list.component.ts